import React from 'react';

import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';

import HistoryIcon from '@material-ui/icons/History';
import SaveIcon from '@material-ui/icons/Save';
import PublishIcon from '@material-ui/icons/Publish';
import QueuePlayNextIcon from '@material-ui/icons/QueuePlayNext';
import AddBoxIcon from '@material-ui/icons/AddBox';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import InsertCommentIcon from '@material-ui/icons/InsertComment';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';

class PackageEditorToolbar extends React.Component {

    render() {
        const { title, onToggleInsertMode, onSavePackage, onExecutePackage, onExecutionHistory, insertMode, selectedQueries, editQuery, deleteQuery } = this.props;
        return (
            <Toolbar disableGutters={true}>
                <Typography style={{ flex: 1 }} variant="title" color="inherit">{title}</Typography>
                <Tooltip id="tooltip-add-query" title="Add Query">
                    <IconButton onClick={() => onToggleInsertMode('query')} color={insertMode === 'query' ? 'secondary' : 'default'}><PlaylistAddIcon /></IconButton>
                </Tooltip>
                <Tooltip id="tooltip-add-text" title="Add Text">
                    <IconButton><InsertCommentIcon /></IconButton>
                </Tooltip>
                <Tooltip id="tooltip-add-rectangle" title="Add Rectangle">
                    <IconButton onClick={() => onToggleInsertMode('rectangle')} color={insertMode === 'rectangle' ? 'secondary' : 'default'}><AddBoxIcon /></IconButton>
                </Tooltip>
                <Tooltip id="tooltip-add-circle" title="Add Circle">
                    <IconButton onClick={() => onToggleInsertMode('circle')} color={insertMode === 'circle' ? 'secondary' : 'default'}><AddCircleIcon /></IconButton>
                </Tooltip>
                <Typography style={{ marginLeft: 20, marginRight: 20, cursor: 'default' }}>|</Typography>
                {
                    selectedQueries.length === 1 && 
                    <Tooltip id="tooltip-edit-query" title="Edit Query">
                        <IconButton onClick={() => editQuery()} color={insertMode === 'circle' ? 'secondary' : 'default'}><EditIcon /></IconButton>
                    </Tooltip>
                }
                {
                    selectedQueries.length === 1 && 
                    <Tooltip id="tooltip-delete-query" title="Delete Query">
                        <IconButton onClick={() => deleteQuery()}><DeleteForeverIcon /></IconButton>
                        {/*  color={insertMode === 'rectangle' ? 'secondary' : 'default'} */}
                    </Tooltip>
                }

                {
                    selectedQueries.length > 0 &&
                    <React.Fragment>
                        <Tooltip id="tooltip-run selected" title="Run Selected">
                            <IconButton><PlayCircleOutlineIcon /></IconButton>
                        </Tooltip>
                        <Typography style={{ marginLeft: 20, marginRight: 20, cursor: 'default' }}>|</Typography>
                    </React.Fragment>
                }
                <Tooltip id="tooltip-save-package" title="Save Package">
                    <IconButton onClick={() => onSavePackage()}><SaveIcon /></IconButton>
                </Tooltip>
                <Tooltip id="tooltip-publish-package" title="Publish Package">
                    <IconButton><PublishIcon /></IconButton>
                </Tooltip>
                <Typography style={{ marginLeft: 20, marginRight: 20, cursor: 'default' }}>|</Typography>
                <Tooltip id="tooltip-execute-package" title="Execute Package">
                    <IconButton onClick={() => onExecutePackage()}><QueuePlayNextIcon /></IconButton>
                </Tooltip>
                <Tooltip id="tooltip-execution-history" title="Execution History">
                    <IconButton onClick={() => onExecutionHistory()}><HistoryIcon /></IconButton>
                </Tooltip>
            </Toolbar>
        );
    }
}
export default PackageEditorToolbar


// WEBPACK FOOTER //
// ./src/Components/Presentation/ETL/PackageEditorToolbar.js